<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>Category</li>
  </ul>
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Agenda Category </strong>
      </span>
      <span style="float: right">
        <button class="btn btn-sm btn-primary mb-2" type="button" 
          [appHasPermission]="{'Url': '/category/edit?goveva=true&email=', 'method':'put', 'menu': 'Category'}"
          (click)="showAddPopUp()">
          <i class="fa fa-plus"></i>&nbsp;Add Category</button>
      </span>
    </div>
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap stripe"
                id="categoryTable" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Category Name</th>
                    <th class="category-list-meeting-type">Meeting Type</th>
                    <th class="category-list-company-global">Company / Global</th>
                    <th class="category-list-action"><span [appHasPermission]="{'Url': '/category/edit?goveva=true&email=', 'method':'put', 'menu': 'Category'}">Action</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let category of categories;">
                    <td tabindex="1">{{category.CategoryName }}</td>
                    <td tabindex="1" class="category-list-meeting-type">{{category.MeetingTypeID.MeetingType}}</td>
                    <td tabindex="2" class="category-list-company-global">
                      <span *ngIf="category.IsGlobal">Global</span>
                      <span *ngIf="!category.IsGlobal">Company Specific</span>
                    </td>
                    <td class="category-list-action">
                      <button type="button" class="btn-sm btn btn-warning" (click)="loadCategoryToEdit(category._id)" [appHasPermission]="{'Url': '/category/edit?goveva=true&email=', 'method':'put', 'menu': 'Category'}">
  
                        <span class="fa fa-pencil"></span>
                      </button>&nbsp;&nbsp;&nbsp;
                      <button type="button" class="btn-sm btn btn-danger" (click)="deleteConfirmation(category._id)" [appHasPermission]="{'Url': '/category/edit?goveva=true&email=', 'method':'put', 'menu': 'Category'}">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table> -->
  
              <table id="categoryDataTable" datatable [dtOptions]="dtOptions2"
                class="table table-hover compact cell-border nowrap stripe">
  
              </table>
            </div>
            <div class="modal fade modal-size-medium" id="categoryDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <form [formGroup]="categoryMasterForm" class="well">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel">
                        <i class="fa fa-plus"></i>&nbsp;Category Master</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-3">
                          <label class="form-control-label">Category Type</label>
                          <span _ngcontent-c2="" style="color: red;">*</span>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
  
                            <div class="md-radio md-radio-inline">
                              <input id="categoryTypeGlobal" type="radio"
                                [formControl]="categoryMasterForm.controls['IsGlobal']" style="position:absolute"
                                name="IsGlobal" value="Global" class="form-check-input" (click)="IsGlobalType('Yes')">
                              <label for="categoryTypeGlobal">Global</label>
                            </div>
  
                            <div class="md-radio md-radio-inline">
                              <input id="categoryTypeCompany" type="radio"
                                [formControl]="categoryMasterForm.controls['IsGlobal']" style="position:absolute"
                                name="IsGlobal" value="Company" class="form-check-input" (click)="IsGlobalType('No')">
                              <label for="categoryTypeCompany">Company</label>
                            </div>
  
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <label class="form-control-label">Default</label>
                          <span _ngcontent-c2="" style="color: red;">*</span>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
                            <div class="md-radio md-radio-inline">
                              <input id="isDefaultYes" type="radio"
                                [formControl]="categoryMasterForm.controls['isDefault']" style="position:absolute"
                                name="payedOvertime" value=true class="form-check-input">
                              <label for="isDefaultYes">Yes</label>
                            </div>
                            <div class="md-radio md-radio-inline">
                              <input id="isDefaultNo" type="radio"
                                [formControl]="categoryMasterForm.controls['isDefault']" style="position:absolute"
                                name="payedOvertime" value=false class="form-check-input">
                              <label for="isDefaultNo">No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <label class="form-control-label" for="l0">Category Name
                            <span _ngcontent-c2="" style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
                            <input [formControl]="categoryMasterForm.controls['CategoryName']" class="form-control"
                              required="required">
                            <div
                              *ngIf="(categoryMasterForm.controls['CategoryName'].hasError('required') || categoryMasterForm.controls['CategoryName'].hasError('whitespace')) && categoryMasterForm.controls['CategoryName'].touched"
                              class="form-control-error-custom">
                              Category name is required.
                            </div>
                            <div *ngIf="categoryMasterForm.controls['CategoryName'].hasError('maxlength') && categoryMasterForm.controls['CategoryName'].touched" 
                                class="form-control-error-custom">
                                Category Name is invalid.
                          </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <label class="form-control-label" for="l0">Meeting Type
                            <span _ngcontent-c2="" style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
                            <select *ngIf="!editGlobalCategory" id="selectMeetingType"
                              [formControl]="categoryMasterForm.controls['MeetingType']" required="required"
                              class="form-control select">
                              <option value="" [selected]="true">Select</option>
                              <option *ngFor="let meetingType of meetingTypes" value={{meetingType._id}}>
                                {{meetingType.MeetingType}}
                              </option>
                            </select>
                            <input id="meetingTypeName" *ngIf="editGlobalCategory && MeetingTypeName==undefined"
                              type="text" [formControl]="categoryMasterForm.controls['MeetingType']" class="form-control">
                            <input *ngIf="editGlobalCategory && MeetingTypeName!=undefined" disabled
                              id="pssMeetingTypeName" type="text" value={{MeetingTypeName}} class="form-control">
                            <div
                              *ngIf="categoryMasterForm.controls['MeetingType'].hasError('required') && categoryMasterForm.controls['MeetingType'].touched"
                              class="form-control-error-custom">
                              Please select meeting type
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button id="btnsaveCategory" type="Submit" class="btn-sm btn btn-primary" [disabled]="!categoryMasterForm.valid || addCategoryDisabledOnclick" (click)="addCategory()">
                        <i class="fa fa-save"></i>&nbsp;Save
                      </button>
                      <button id="btnupdateCategory" style="display:none;" type="button" class="btn btn-sm btn-primary" [disabled]="!categoryMasterForm.valid || addCategoryDisabledOnclick"
                        (click)="editCategory()">
                        <i class="fa fa-save"></i>&nbsp;Update
                      </button>
                      <button type="button" class="btn btn-sm" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Close
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div id="alertTitle" class="modal-header"
                    style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                    Title!
                  </div>
                  <div class="modal-body">
                    <div id="alertMessage">
                      Message..
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                      <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                        Are you sure you want to delete this category?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteCategory()">
                      <i class="fa fa-check"></i>&nbsp;Yes
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                      <i class="fa fa-times"></i>&nbsp;No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-alert></app-alert>
  </section>